import React from 'react';
import { Link } from 'react-router-dom';
import { TranslatableText } from '../../../providers/LanguageProvider';

import appStore from '../../../pages/Order/i/app-store-download.png';
import googleStore from '../../../pages/Order/i/google-store-download.png';
import appStoreFR from '../../../pages/Order/i/app-store-download-fr.png';
import googleStoreFR from '../../../pages/Order/i/google-store-download-fr.png';

import './style.scss';

const Links = (props) => (

    <React.Fragment>
        <div className="linkcols">
            <div className="left">
                <ul className="links">
                    <li>
                        <Link to={`/${props.lang}/our-menu`}>
                        <TranslatableText dictionary={{
                            en: "Our Menu",
                            fr: "Notre menu" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <Link to={`/${props.lang}/our-values`}>
                        <TranslatableText dictionary={{
                            en: "Our Values",
                            fr: "Nos valeurs" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <Link to={`/${props.lang}/order`}>
                        <TranslatableText dictionary={{
                            en: "Our App",
                            fr: "Notre appli" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <Link to={`/${props.lang}/company`}>
                        <TranslatableText dictionary={{
                            en: "Our Company",
                            fr: "Notre entreprise" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <a href={props.lang === 'fr' ? 'https://awfranchise.ca/fr' : 'https://awfranchise.ca' }>
                        <TranslatableText dictionary={{
                            en: "Franchise Info",
                            fr: "Information sur les franchises" }}>
                        </TranslatableText> 
                        </a>
                    </li>
                    <li>
                        <a href="https://awinvestors.ca">
                        <TranslatableText dictionary={{
                            en: "Investor Relations",
                            fr: "Relations investisseurs" }}>
                        </TranslatableText> 
                        </a>
                    </li>
                    <li>
                        <Link to={`/${props.lang}/locations`}>
                        <TranslatableText dictionary={{
                            en: "Locations",
                            fr: "Restaurants" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <Link to={`/${props.lang}/gift-cards`}>
                        <TranslatableText dictionary={{
                            en: "Gift Cards",
                            fr: "Cartes-cadeaux" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <a href="https://www.awcda.ca/">
                        <TranslatableText dictionary={{
                            en: "Operator Login",
                            fr: "Entrée des exploitants" }}>
                        </TranslatableText> 
                        </a>
                    </li>
                </ul>
            </div>
            <div className="right">
                <ul className="links">
                    <li>
                        <Link to={`/${props.lang}/contact-us`}>
                        <TranslatableText dictionary={{
                            en: "Contact Us",
                            fr: "Contactez-nous" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <Link to={`/${props.lang}/faq`}>
                        <TranslatableText dictionary={{
                            en: "FAQ",
                            fr: "Foire aux questions" }}>
                        </TranslatableText> 
                        </Link>
                    </li>
                    <li>
                        <a href={props.lang === 'fr' ? 'https://workwithus.aw.ca/jobs-fr' : 'https://workwithus.aw.ca/'}>
                        <TranslatableText dictionary={{
                            en: "Work with Us",
                            fr: "Travailler avec nous" }}>
                        </TranslatableText> 
                        </a>
                    </li>
                </ul>
                {props.lang === 'en' ?  
                        <>
                        <a href="https://apps.apple.com/ca/app/a-w/id1236416092" className="app-btn" title="" ><img src={appStore} alt="apple store download" /></a>
                        <a href="https://play.google.com/store/apps/details?id=com.myelane2_aw" className="app-btn" title="" ><img src={googleStore} alt="google play download" /></a>
                        </>
                    :
                        <>
                        <a href="https://apps.apple.com/ca/app/a-w/id1236416092" className="app-btn" title="" ><img src={appStoreFR} alt="apple store download" /></a>
                        <a href="https://play.google.com/store/apps/details?id=com.myelane2_aw" className="app-btn"><img src={googleStoreFR} alt="google play download" /></a>
                        </>
                    }
            </div>
        </div>
    </React.Fragment>

)
export default Links;